/*
  MWN pack-savings sync — approved 2026-09-02.

  Fixes a real bug found in staging QA: the "Save $X" line on Drawer/Travel
  PDPs (rendered by sections/main-product.liquid, id="Savings-{section.id}")
  sits as a sibling of the price block, not inside it. Dawn's own
  assets/product-info.js only swaps a fixed list of elements by id on an
  in-page Pack switch (price / Sku / Inventory / Volume / Price-Per-Item —
  see updateSourceFromDestination in that file). "Savings" isn't one of
  them, so a shopper clicking a Pack size without a full page reload never
  saw the line appear, update, or disappear.

  Rather than editing sections/main-product.liquid (large file, high risk
  to hand-edit), this listens for the same variant-change event Dawn
  itself publishes and manually syncs the Savings element the same way
  Dawn already syncs price/Sku/Inventory — but this handles insertion and
  removal too, since Dawn's own helper only handles element-to-element
  swaps when both the old and new element already exist.

  Fix 2026-09-02: on Drawer products, price-{section.id} always carries
  Dawn's "hidden" class, because sections/main-product.liquid hides it
  whenever product.selling_plan_groups.size > 0 — a PRODUCT-level check.
  Drawer's 1-Pack variant carries a Seal Subscribe & Save selling plan
  group (2-Pack/3-Pack don't), so that check is true for every Drawer
  variant, and the plain price div stays hidden at all times (Seal's own
  widget renders the visible price instead). Travel has no selling plan
  groups on any variant, so its price div is never hidden. The original
  version of this script inserted a newly-appearing Savings element as a
  CHILD of price-{section.id} — invisible on Drawer, fine on Travel. It
  now inserts Savings as a SIBLING immediately after price-{section.id},
  matching the static Liquid markup exactly, so it renders regardless of
  whether the price div itself is hidden.

  Safe on every product: when a product has no Savings element (no
  compare-at price on the selected variant), this is a no-op both before
  and after a variant switch.
*/
(function () {
  if (window.__mwnSavingsSyncInit) return;
  window.__mwnSavingsSyncInit = true;

  function sync(sectionId, html) {
    if (!sectionId || !html) return;

    var newSavings = html.getElementById('Savings-' + sectionId);
    var oldSavings = document.getElementById('Savings-' + sectionId);
    var priceDiv = document.getElementById('price-' + sectionId);

    if (newSavings) {
      if (oldSavings) {
        oldSavings.replaceWith(newSavings.cloneNode(true));
      } else if (priceDiv) {
        priceDiv.insertAdjacentElement('afterend', newSavings.cloneNode(true));
      }
    } else if (oldSavings) {
      oldSavings.remove();
    }
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data ? event.data : {};
      sync(data.sectionId, data.html);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
